// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/customer_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { CustomerService } from "./customer_service_pb";

/**
 * @generated from rpc bffuser.v1.CustomerService.ListCustomers
 */
export const listCustomers = CustomerService.method.listCustomers;

/**
 * area_code 未指定は全エリア。
 *
 * @generated from rpc bffuser.v1.CustomerService.ListCustomerSupplyPoints
 */
export const listCustomerSupplyPoints = CustomerService.method.listCustomerSupplyPoints;

/**
 * 契約推移の日別集計 (区分「契約」だけ・供給期間内)。
 *
 * @generated from rpc bffuser.v1.CustomerService.GetContractTrend
 */
export const getContractTrend = CustomerService.method.getContractTrend;

/**
 * @generated from rpc bffuser.v1.CustomerService.GetCustomerSupplyPointFormOptions
 */
export const getCustomerSupplyPointFormOptions = CustomerService.method.getCustomerSupplyPointFormOptions;

/**
 * @generated from rpc bffuser.v1.CustomerService.CreateCustomerSupplyPoint
 */
export const createCustomerSupplyPoint = CustomerService.method.createCustomerSupplyPoint;

/**
 * @generated from rpc bffuser.v1.CustomerService.UpdateCustomerSupplyPoint
 */
export const updateCustomerSupplyPoint = CustomerService.method.updateCustomerSupplyPoint;

/**
 * UpdateCustomer は需要家名を直す (社名変更)。
 *
 * @generated from rpc bffuser.v1.CustomerService.UpdateCustomer
 */
export const updateCustomer = CustomerService.method.updateCustomer;

/**
 * @generated from rpc bffuser.v1.CustomerService.ConvertProspectToContract
 */
export const convertProspectToContract = CustomerService.method.convertProspectToContract;

/**
 * @generated from rpc bffuser.v1.CustomerService.MarkProspectLost
 */
export const markProspectLost = CustomerService.method.markProspectLost;

/**
 * @generated from rpc bffuser.v1.CustomerService.GetCustomerSupplyPointDeletability
 */
export const getCustomerSupplyPointDeletability = CustomerService.method.getCustomerSupplyPointDeletability;

/**
 * @generated from rpc bffuser.v1.CustomerService.DeleteCustomerSupplyPoint
 */
export const deleteCustomerSupplyPoint = CustomerService.method.deleteCustomerSupplyPoint;
